export default "__VITE_ASSET__BM$LB2FY__"